import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../ConditionRegistryItem';
export class ConditionRegistryAsking extends ConditionRegistryCategory {
    label = 'Asking';
    constructor(parent) {
        super(parent);
        super.init();
    }
    answerMarkPassed = () => new ConditionRegistryItem({
        eval: ({ condition, app }) => {
            return app.asking.askingMarks.answerMarkNames.includes(condition.local.valueOf.markName);
        },
    });
    timeRangeIsActive = () => new ConditionRegistryItem({
        eval: ({ condition, app }) => {
            return app.mediaPlayer.playerPlaying.activeTimeRanges
                .map(timeRange => timeRange.markName)
                .includes(condition.local.valueOf.markName);
        },
    });
}
